import BaseDevice from '../base.js'
import Switch from './switch.js'
export default class DeviceImage extends BaseDevice {
   static render(device, scale = 1) {
      const MODS = this.getMods(device.width)
      if (MODS <= 1 || MODS >= 8) return;
      return this.getDevice(device, scale, Switch.render(device.width, MODS));
   }
}
